const localizers = {
  'loading.msg': () => `로드 중...`,
  'SASServer.genericError.msg': () => `서버에 연결할 수 없습니다.`,
  'SASReport.genericError.msg': () => `선택한 리포트를 로드할 수 없습니다.`,
  'SASReportImage.genericError.msg': () => `리포트 이미지를 로드하지 못했습니다.`,
  'SASReportImage.imageNotSupported.msg': () => `이 리포트 콘텐츠 유형에는 이미지가 지원되지 않습니다.`,
}
export default localizers;
